module.exports = __webpack_public_path__ + "static/media/mobilesdk.2279b923.svg";